import styles from './Loader.module.css';

/**
 * Reusable Loader component.
 */
export default function Loader({ size = 'medium', className = '' }) {
  const sizeClass = size === 'small' ? styles.loaderSmall : size === 'large' ? styles.loaderLarge : '';

  return (
    <div className={`${styles.loader} ${sizeClass} ${className}`.trim()} role="status" aria-label="Loading">
      <div className={styles.spinner} />
    </div>
  );
}
